<template>
  <!-- 视力筛查  -->
  <div v-if="model && model.vision">
    <div id="print_vision" class="page vision-page" style="margin:0 auto; border:0px solid #E8E8EC;">
      <div style="height: 50px;"></div>
      <div style="font-size: 18px;"><span>{{ model.vision.hospitalName ? model.vision.hospitalName : "" }}</span></div>
      <div style="font-size: 22px;padding: 20px 0 30px 0;font-weight: 600;"><span>{{ model.vision.reportName ? model.vision.reportName : "屈光筛查报告" }}</span></div>

      <table style="margin-top: 15px;margin-left: 15px;margin-right: 8px;text-align: left;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">学校：<span>{{ model.vision.schoolName ? model.vision.schoolName : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">年级：<span>{{ model.vision.gradeName ? model.vision.gradeName : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">班级：<span>{{ model.vision.className ? model.vision.className : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">编号：<span>{{ model.vision.barCode ? model.vision.barCode : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">筛查时间：<span>{{ model.vision.screeningTime ? model.vision.screeningTime : "" }}</span></td>
          </tr>
          <tr style="line-height: 35px;width: 100%;border-collapse: collapse;text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">姓名：<span>{{ model.vision.name ? model.vision.name : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">性别：<span>{{ model.vision.sex ? model.vision.sex : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">年龄：<span>{{ model.vision.age ? model.vision.age : "" }}</span></td>
          </tr>
        </tbody>
      </table>
      <div style="border-bottom:1px solid rgb(14, 14, 14);"></div>

      <table style="text-align: center;margin-top: 10px;margin-left: 15px;padding-top:20px;padding-bottom:20px;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="line-height: 25px;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">眼睛</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">指标</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">检查结果</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">范围</td>
            <td style="width: 100px;border-collapse: collapse;border:none;border-right: 2px solid rgb(0, 0, 0);">指示</td>
            <td style="width:25px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">眼睛</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">指标</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">检查结果</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">范围</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">指示</td>
          </tr>
          <tr style="line-height: 25px;border:none;">
            <td style="color: rgb(66, 100, 216);width: 100px;border-collapse: collapse;border:none;">右眼</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">s球径<span style="color: rgb(255, 83, 86);">*</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.vision.rightEyeSBallDiameter ? model.vision.rightEyeSBallDiameter : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.vision.sballNormalRange ? model.vision.sballNormalRange : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;border-right: 2px solid rgb(0, 0, 0);"><span>{{ model.vision.rightEyeSBallDiameterIndication ? model.vision.rightEyeSBallDiameterIndication : "" }}</span></td>
            <td style="width:25px;border-collapse: collapse;border:none;"></td>

            <td style="color: rgb(66, 100, 216);width: 100px;border-collapse: collapse;border:none;">左眼</td>
            <td style="width: 100px;border-collapse: collapse;border:none;">s球径<span style="color: rgb(255, 83, 86);">*</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.vision.leftEyeSBallDiameter ? model.vision.leftEyeSBallDiameter : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.vision.sballNormalRange ? model.vision.sballNormalRange : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.vision.leftEyeSBallDiameterIndication ? model.vision.leftEyeSBallDiameterIndication : "" }}</span></td>
          </tr>
          <tr style="line-height: 25px;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">c柱径<span style="color: rgb(255, 83, 86);">*</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.vision.rightEyeCColumnDiameter ? model.vision.rightEyeCColumnDiameter : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.vision.cballNormalRange ? model.vision.cballNormalRange : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;border-right: 2px solid rgb(0, 0, 0);"><span>{{ model.vision.rightEyeCColumnDiameterIndication ? model.vision.rightEyeCColumnDiameterIndication : "" }}</span></td>
            <td style="width:25px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"></td>
            <td style="width: 100px;border-collapse: collapse;border:none;">c柱径<span style="color: rgb(255, 83, 86);">*</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.vision.leftEyeCColumnDiameter ? model.vision.leftEyeCColumnDiameter : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.vision.cballNormalRange ? model.vision.cballNormalRange : "" }}</span></td>
            <td style="width: 100px;border-collapse: collapse;border:none;"><span>{{ model.vision.leftEyeCColumnDiameterIndication ? model.vision.leftEyeCColumnDiameterIndication : "" }}</span></td>
          </tr>
        </tbody>
      </table>

      <div style="text-align: left;margin-top: 10px;padding-top:10px;padding-left: 15px;padding-bottom:10px;border-bottom:1px solid rgb(14, 14, 14);">
        筛查设备：<span>{{ model.vision.screeningEquipment }}</span>
      </div>

      <table style="margin-top: 10px;margin-left: 15px;width: 100%;border-collapse: collapse;border:none;">
        <tbody>
          <tr style="text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【筛查小结】</p></div>
              <div style="min-height: 20px;"><p>{{ model.vision.screeningSummary ? model.vision.screeningSummary : "" }}</p></div>
            </td>
          </tr>
          <tr style="text-align: left;border:none;">
            <td style="width: 100px;border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【建议】</p></div>
              <div style="min-height: 20px;"><p>{{ model.vision.recommendations ? model.vision.recommendations : "" }}</p></div>
            </td>
          </tr>
          <tr style="text-align: left;border:none;">
            <td class="refractive_childrenVisionCareTips" style="width: 100px;border-collapse: collapse;border:none;">
              <div><p style="font-size: 16px;font-weight: bold;">【儿童视力保健提示】</p></div>
              <div v-for="(item, index) in model.vision.childrenVisionCareTips" style="min-height: 20px;"><p>{{ item ? item : "" }}</p></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</template>
<script>

import {_vision} from "@/services/report/report";
export default {
  name: "visionReport",
  props: {
    physicalId: [String, Number],
    barCode: [String, Number],
    reportCode: [String],
    printData: {
      type: Object,
      default: {}
    },
  },
  data() {
    return {
      model: {
        vision:{
          reportName: "",
          hospitalName: "",
          name: "",
        }
      },
    }
  },
  watch:{
    reportCode:{
      handler(newVal,oldVal){
        if(newVal === 'vision'){
          this.loadData();
        }
      }
    },
    printData: {
      handler(newVal) {
        if (newVal && this.reportCode === 'vision') {
          this.model = newVal;
        }
      }
    }
  },
  created() {

  },
  mounted() {

  },
  onLoad() {
    console.log("onLoad")
  },
  onUnLoad(){
    console.log("onUnLoad")
  },
  onReady () {
    console.log("onReady")
  },
  methods: {
    loadData(){
      if(this.barCode){
        this.vision(this.barCode);
      }
    },
    vision(barCode) {
      _vision({barCode: barCode}).then(res => {
        if (res.errcode !== 1) {
          this.$Message.error(res.errmsg);
          return;
        }
        this.$emit('on-setReportData', res.data);
        this.model = res.data;
      })
    },
  }
};
</script>
<style lang="postcss" scoped>
@media print {
  .vision-page {
    page: vision-page; /* 绑定唯一命名 */
  }
  @page vision-page {size: A4;margin: 0;}
  body {width: 210mm;height: 297mm;margin: 0 auto;background: white;}
  .no-print { display: none; } /* 隐藏非打印元素 */
}
.page {width: 210mm;height: 297mm;text-align: center;margin:0 auto;padding-top:10px;padding-left:40px;padding-right:40px;overflow: hidden;position: relative;PAGE-BREAK-AFTER: always;background: #fff;}

</style>
